export default __webpack_public_path__ + "static/media/8f61dfad904efeab5447d34c687b0bb71600804422663.1fbefda2.webp";